import { RouteParameters } from "./route-parameters";

const SUPPORT_VEHICLE_ROUTING = {
  ORGANIZATION_DETAILS: `/dashboard/support-vehicles/:${RouteParameters.SUPPORT_VEHICLE_ID}/organization-details`,
  PROFILE_DETAILS: `/dashboard/support-vehicles/:${RouteParameters.SUPPORT_VEHICLE_ID}/profile-details`,
  RISK: {
    CREATE: {
      ROOT: `/dashboard/support-vehicles/:${RouteParameters.SUPPORT_VEHICLE_ID}/risk/create`,
      [RouteParameters.RISK_FORM_ID]: {
        ROOT: `/dashboard/support-vehicles/:${RouteParameters.SUPPORT_VEHICLE_ID}/risk/create/:${RouteParameters.RISK_FORM_ID}`,
      },
    },
    ROOT: `/dashboard/support-vehicles/:${RouteParameters.SUPPORT_VEHICLE_ID}/risk`,
    SELECT: `/dashboard/support-vehicles/:${RouteParameters.SUPPORT_VEHICLE_ID}/risk/select`,
    VIEW: `/dashboard/support-vehicles/:${RouteParameters.SUPPORT_VEHICLE_ID}/risk/view`,
  },
  ROOT: `/dashboard/support-vehicles/:${RouteParameters.SUPPORT_VEHICLE_ID}`,
} as const;

const SUPPORT_VEHICLE_RISK_ROUTES = [
  SUPPORT_VEHICLE_ROUTING.RISK.ROOT,
  SUPPORT_VEHICLE_ROUTING.RISK.CREATE.ROOT,
  SUPPORT_VEHICLE_ROUTING.RISK.VIEW,
  SUPPORT_VEHICLE_ROUTING.RISK.SELECT,
  SUPPORT_VEHICLE_ROUTING.RISK.CREATE[RouteParameters.RISK_FORM_ID].ROOT,
] as const;

export { SUPPORT_VEHICLE_RISK_ROUTES, SUPPORT_VEHICLE_ROUTING };
